import React from 'react';
import { Outlet } from 'react-router-dom';
import { PageHeader } from '../header/PageHeader';
import { Footer } from '../footer/Footer';
import { LiveHeader, LiveFooter } from './XBPageLayoutComponents';

/**
 * Default layout with standard PageHeader and Footer
 */
export const DefaultLayout: React.FC = () => {
    return (
        <div id='my-class-legacy-container' data-testid='my-class-legacy-container'>
            <PageHeader />
            <Outlet />
            <Footer />
        </div>
    );
};

/**
 * XB layout using live components
 */
export const XBLayout: React.FC = () => {
    return (
        <span data-testid='my-class-container'>
            <div id='my-class-header-container'>
                <LiveHeader />
            </div>
            <Outlet />
            <div id='my-class-footer-container'>
                <LiveFooter />
            </div>
        </span>
    );
};

/**
 * Main layout component that conditionally renders based on isXBEnabled flag
 */
export const MainLayout = ({ isXbEnabled }: { isXbEnabled: boolean }) => {
    return isXbEnabled ? <XBLayout /> : <DefaultLayout />;
};
